import Onyx from './Onyx';
import image from './preview.png';

export const Image = image;
export default Onyx;
